// src/components/ui/forms/PasswordInput/PasswordInput.jsx
import React, { useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import Input from '../Input/Input';

const PasswordInput = ({
  value,
  onChange,
  placeholder = "Enter your password",
  showToggle = true,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleButton = showToggle && (
    <button
      type="button"
      onClick={toggleVisibility}
      className="text-slate-400 hover:text-slate-300 transition-colors"
      tabIndex={-1}
    >
      {showPassword ? (
        <EyeOff className="w-5 h-5" />
      ) : (
        <Eye className="w-5 h-5" />
      )}
    </button>
  );

  return (
    <Input
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      leftIcon={Lock}
      rightElement={toggleButton}
      {...props}
    />
  );
};

export default PasswordInput;